"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _reduxForm = require("redux-form");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _authMiddleware = _interopRequireDefault(require("./middlewares/authMiddleware"));
var _placeOrderMiddleware = _interopRequireDefault(require("./middlewares/placeOrderMiddleware"));
var _startupMiddleware = _interopRequireDefault(require("./middlewares/startupMiddleware"));
var _wsConnectionMiddleware = _interopRequireDefault(require("./middlewares/wsConnectionMiddleware"));
var _orderFeeMiddleware = _interopRequireDefault(require("./middlewares/orderFeeMiddleware"));
var _priceQuantityIncrementMiddleware = _interopRequireDefault(require("./middlewares/priceQuantityIncrementMiddleware"));
var _level2monitorMiddleware = _interopRequireDefault(require("./middlewares/level2monitorMiddleware"));
var _authActions = require("./actions/authActions");
var _affiliateReducer = _interopRequireDefault(require("./reducers/affiliateReducer"));
var _apiReducer = _interopRequireDefault(require("./reducers/apiReducer"));
var _apiKeyReducer = _interopRequireDefault(require("./reducers/apiKeyReducer"));
var _apiProcessingReducer = _interopRequireDefault(require("./reducers/apiProcessingReducer"));
var _authReducer = _interopRequireDefault(require("./reducers/authReducer"));
var _confirmWithdrawReducer = _interopRequireDefault(require("./reducers/confirmWithdrawReducer"));
var _verifyAddressReducer = _interopRequireDefault(require("./reducers/verifyAddressReducer"));
var _verifyDeviceReducer = _interopRequireDefault(require("./reducers/verifyDeviceReducer"));
var _eotcReducer = _interopRequireDefault(require("./reducers/eotcReducer"));
var _eotcWithdrawReducer = _interopRequireDefault(require("./reducers/eotcWithdrawReducer"));
var _eotcSettlementReducer = _interopRequireDefault(require("./reducers/eotcSettlementReducer"));
var _eotcPriceReducer = _interopRequireDefault(require("./reducers/eotcPriceReducer"));
var _depositReducer = _interopRequireDefault(require("./reducers/depositReducer"));
var _loyaltyFeeReducer = _interopRequireDefault(require("./reducers/loyaltyFeeReducer"));
var _modalReducer = _interopRequireDefault(require("./reducers/modalReducer"));
var _paginationReducer = _interopRequireDefault(require("./reducers/paginationReducer"));
var _productAttributesReducer = _interopRequireDefault(require("./reducers/productAttributesReducer"));
var _productManifestReducer = _interopRequireDefault(require("./reducers/productManifestReducer"));
var _recentTradesReducer = _interopRequireDefault(require("./reducers/recentTradesReducer"));
var _resetPasswordReducer = _interopRequireDefault(require("./reducers/resetPasswordReducer"));
var _reportReducer = _interopRequireDefault(require("./reducers/reportReducer"));
var _sidePaneReducer = _interopRequireDefault(require("./reducers/sidePaneReducer"));
var _signupReducer = _interopRequireDefault(require("./reducers/signupReducer"));
var _snackbarReducer = _interopRequireDefault(require("./reducers/snackbarReducer"));
var _tickersReducer = _interopRequireDefault(require("./reducers/tickersReducer"));
var _transferReducer = _interopRequireDefault(require("./reducers/transferReducer"));
var _transferRequestReducer = _interopRequireDefault(require("./reducers/transferRequestReducer"));
var _transferRequestRequestedReducer = _interopRequireDefault(require("./reducers/transferRequestRequestedReducer"));
var _userReducer = _interopRequireDefault(require("./reducers/userReducer"));
var _verifyEmailReducer = _interopRequireDefault(require("./reducers/verifyEmailReducer"));
var _withdrawReducer = _interopRequireDefault(require("./reducers/withdrawReducer"));
var _wsConnectionReducer = _interopRequireDefault(require("./reducers/wsConnectionReducer"));
var _interestBearingAccountsReducer = _interopRequireDefault(require("./reducers/interestBearingAccountsReducer"));
var _apexCore = _interopRequireDefault(require("./apexCore"));
var _marginReducer = require("./margin/reducers/marginReducer");
var _snackOverrideMiddleware = _interopRequireDefault(require("./middlewares/snackOverrideMiddleware"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } // reducers (sort by name)
var composeEnhancers = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  actionsBlacklist: ['LEVEL1_LOADED', 'LEVEL_2_UPDATES', 'REGISTER_FIELD', 'ADD_TICKERS', 'ADD_RECENT_TRADE']
}) : _redux.compose;
var appReducer = (0, _redux.combineReducers)({
  api: _apiReducer["default"],
  apiKey: _apiKeyReducer["default"],
  apexCore: _apexCore["default"],
  affiliate: _affiliateReducer["default"],
  auth: _authReducer["default"],
  form: _reduxForm.reducer,
  eotc: _eotcReducer["default"],
  eotcWithdraw: _eotcWithdrawReducer["default"],
  eotcSettlement: _eotcSettlementReducer["default"],
  eotcPrices: _eotcPriceReducer["default"],
  margin: _marginReducer.marginReducer,
  modal: _modalReducer["default"],
  productAttributes: _productAttributesReducer["default"],
  productManifest: _productManifestReducer["default"],
  recentTrades: _recentTradesReducer["default"],
  report: _reportReducer["default"],
  sidePane: _sidePaneReducer["default"],
  signup: _signupReducer["default"],
  snackbar: _snackbarReducer["default"],
  user: _userReducer["default"],
  apiProcessing: _apiProcessingReducer["default"],
  deposit: _depositReducer["default"],
  withdraw: _withdrawReducer["default"],
  wsConnection: _wsConnectionReducer["default"],
  tickers: _tickersReducer["default"],
  transfer: _transferReducer["default"],
  transferRequest: _transferRequestReducer["default"],
  paginationMemory: _paginationReducer["default"],
  verifyEmail: _verifyEmailReducer["default"],
  confirmWithdraw: _confirmWithdrawReducer["default"],
  resetPassword: _resetPasswordReducer["default"],
  loyaltyFee: _loyaltyFeeReducer["default"],
  transferRequestRequested: _transferRequestRequestedReducer["default"],
  interestBearingAccounts: _interestBearingAccountsReducer["default"],
  verifyAddress: _verifyAddressReducer["default"],
  verifyDevice: _verifyDeviceReducer["default"]
});
var rootReducer = function rootReducer(state, action) {
  // Reset all state to initial values on logout (AUTH_NONE)
  // This ensures no user data persists when switching between users
  if (action.type === _authActions.AUTH_NONE) {
    state = undefined;
  }
  return appReducer(state, action);
};
var store = (0, _redux.createStore)(rootReducer, undefined, composeEnhancers((0, _redux.applyMiddleware)(_level2monitorMiddleware["default"], _priceQuantityIncrementMiddleware["default"], _placeOrderMiddleware["default"], _startupMiddleware["default"], _orderFeeMiddleware["default"], _authMiddleware["default"], _snackOverrideMiddleware["default"], _wsConnectionMiddleware["default"], _reduxThunk["default"])));
var _default = exports["default"] = store;